export enum RequestChangeHistoryType {
  EDIT,
  EMAIL
}
